import { atom } from "recoil";
import paths from "../route/paths";

export interface LayoutModeProps {
  layoutMode: string;
}

export interface lastLocationProps {
  location: string;
}

export interface filterSelectorProps {
  pageIndex: number;
  globalSearch: string;
  countrySearch: string;
  districtSearch: string;
  neighbourhoodSearch: string;
  addressDescriptionSearch: string;
  phoneNumberSearch: string;
  streetSearch: string;
  minDays: string;
  maxDays: string;
}

export const layoutThemeSelector = atom<LayoutModeProps>({
  key: "layoutThemeSelector",
  default: { layoutMode: "light" },
});

export const lastLocationSelector = atom<lastLocationProps>({
  key: "lastLocationSelector",
  default: { location: paths.CUSTOMER.CUSTORMER_LIST },
});

export const flutterMessageSelector = atom<string>({
  key: "flutterMessageState",
  default: "",
});

export const webViewSelector = atom<boolean>({
  key: "webViewSelector",
  default: false,
});

export const filterSelector = atom<filterSelectorProps>({
  key: "filterSelector",
  default: {
    pageIndex: 0,
    globalSearch: "",
    countrySearch: "",
    districtSearch: "",
    neighbourhoodSearch: "",
    addressDescriptionSearch: "",
    phoneNumberSearch: "",
    streetSearch: "",
    minDays: "",
    maxDays: "",
  },
});
